/* eslint-disable react-hooks/rules-of-hooks */

import { getDotcmsImageURL } from './getDotcmsImageURL';

export const loadImageFromDotCMS = ({ src, width, quality, forceHighQuality }) => {
    // No longer exists in the new SDK
    // const context = useDotcmsPageContext();

    const DEFAULT_LANGUAGE_ID = 1;
    const DEFAULT_QUALITY = 75;
    const FORCE_QUALITY = 95;

    const WIDTH_XS = 375;
    const WIDTH_SM = 640;
    const WIDTH_MD = 768;
    const WIDTH_LG = 1024;

    const QUALITY_DIVISOR_XS = 3;
    const QUALITY_DIVISOR_SM = 2.5;
    const QUALITY_DIVISOR_MD = 2;
    const QUALITY_DIVISOR_LG = 1.5;

    // const languageId = context?.pageAsset?.viewAs?.language.id ?? DEFAULT_LANGUAGE_ID;
    const languageId = DEFAULT_LANGUAGE_ID;

    const MAX_WIDTH = 1024;
    const normalizedWidth = width && width !== 0 ? Number(width) : null;
    const limitedWidthForProcessing = normalizedWidth ? Math.min(normalizedWidth, MAX_WIDTH) : null;

    const finalQuality = forceHighQuality
        ? FORCE_QUALITY
        : (() => {
              const baseQuality = quality ?? DEFAULT_QUALITY;
              return limitedWidthForProcessing && limitedWidthForProcessing <= WIDTH_XS
                  ? Math.floor(baseQuality / QUALITY_DIVISOR_XS)
                  : limitedWidthForProcessing && limitedWidthForProcessing <= WIDTH_SM
                    ? Math.floor(baseQuality / QUALITY_DIVISOR_SM)
                    : limitedWidthForProcessing && limitedWidthForProcessing <= WIDTH_MD
                      ? Math.floor(baseQuality / QUALITY_DIVISOR_MD)
                      : limitedWidthForProcessing && limitedWidthForProcessing <= WIDTH_LG
                        ? Math.floor(baseQuality / QUALITY_DIVISOR_LG)
                        : baseQuality;
          })();

    const dotcmsURL = getDotcmsImageURL({
        src,
        width: limitedWidthForProcessing,
        quality: finalQuality
    });

    const queryParams = [];

    if (limitedWidthForProcessing) {
        queryParams.push(`w=${limitedWidthForProcessing}`);
    }

    queryParams.push(`language_id=${languageId ?? DEFAULT_LANGUAGE_ID}`);

    const paramsString = queryParams.join('&');

    const separator = dotcmsURL.includes('?') ? '&' : '?';
    return `${dotcmsURL}${separator}${paramsString}`;
};

export const loadImageFromAsset = ({ src, width }) => {
    return `${src.trim()}${width ? '?w=' + width : ''}`;
};

const imageLoader = ({ src, width, quality }) => {
    const assetsRegex = new RegExp(/^\/assets\//);

    // 100 is the sentinel for "force max quality" — Next 15 caps qualities at
    // 100 in its config validation, so this replaces the previous 101 sentinel.
    // The loader itself substitutes FORCE_QUALITY (95) into the outgoing URL,
    // so callers passing exactly 100 still get near-max output.
    const shouldForceHighQuality = quality === 100 ? true : false;
    const normalizedQuality = quality === 100 ? undefined : quality;

    return assetsRegex.test(src)
        ? loadImageFromAsset({ src, width })
        : loadImageFromDotCMS({
              src,
              width,
              quality: normalizedQuality,
              forceHighQuality: shouldForceHighQuality
          });
};

export default imageLoader;
